import React from 'react';
import styled from 'styled-components';
import Description from './component/Description';
import Header from './component/Header';
import Table from './component/Table';
import { AudioSrcDictType, ColumnType } from './component/Type';

function App() {
  const columns_name_list: Array<ColumnType> = [
    {column_name: "Song Name", description: ""},
    {column_name: "Music (Input)", description: "(Dry Vocal + Reverb of Vocal + Accom)"},
    {column_name: "Wet vocal", description: "(Dry Vocal + Reverb of Vocal)"},
    {column_name: "Dry vocal (GT)", description: ""},
    {column_name: "SSSynth", description: ""},
    {column_name: "ResUNetDecouple", description: ""},
    {column_name: "Proposed1", description: "w/o Singing Voice Detector"},
    {column_name: "Proposed2", description: "w/ Singing Voice Detector"}
  ]
  const song_name_list: Array<string> = [
    'TheLongWait-DarkHorses',
    'HollowGround-IllFate',
    'M.E.R.C.Music-Knockout',
    'TomMcKenzie-Directions',
    'LyndseyOllard-CatchingUp',
    'Secretariat-Borderline',
    'SelwynJazz-MuchTooMuch',
    'AlJames-SchoolboyFacination',
    'TheMountaineeringClub-Mallory',
    'Nerve9-PrayForTheRain'
  ]

  const audio_src_list: Array<AudioSrcDictType> = song_name_list.map(
    (song_name) => {
      return{
        song_name: song_name,
        input: "./mp3/".concat(song_name,"_1_music_input.mp3"),
        wet_vocal: "./mp3/".concat(song_name,"_2_gt_w_reverb.mp3"),
        dry_vocal: "./mp3/".concat(song_name,"_3_gt.mp3"),
        sssynth: "./mp3/".concat(song_name,"_4_pred_by_separation_by_world.mp3"),
        res_unet_decouple: "./mp3/".concat(song_name,"_5_predbybytedance.mp3"),
        proposed1: "./mp3/".concat(song_name,"_7_predbymelmaskingresynthbyhifigan.mp3"),
        proposed2: "./mp3/".concat(song_name,"_8_predbymelmaskingsvdetectmaskedresynthbyhifigan.mp3")
      }
    }
  )

  return (
    <AppDiv className="Appadsd2">
      <Header/>
      <Description></Description>
      <Table columns_name_list={columns_name_list} audio_src_list={audio_src_list}/>
    </AppDiv>
  );
}

const AppDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export default App;
